(function() {
    'use strict';

    angular
        .module('masterApp')
        .controller('ReasonWriteOffDetailController', ReasonWriteOffDetailController);

    ReasonWriteOffDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'DataUtils', 'entity', 'ReasonWriteOff'];

    function ReasonWriteOffDetailController($scope, $rootScope, $stateParams, DataUtils, entity, ReasonWriteOff) {
        var vm = this;

        vm.reasonWriteOff = entity;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        if(vm.reasonWriteOff.status == 1){
        	vm.reasonWriteOff.statusName = 'Đang hoạt động'
        }else{
        	vm.reasonWriteOff.statusName = 'Ngừng hoạt động'
        }
        
        if(vm.reasonWriteOff.typeReason == 'NORMAL'){
        	vm.reasonWriteOff.typeReasonName = 'Bình thường'
        }else if(vm.reasonWriteOff.typeReason == 'RETURN'){
        	vm.reasonWriteOff.typeReasonName = 'Hoàn trả'
        }else if(vm.reasonWriteOff.typeReason == 'LOST'){
        	vm.reasonWriteOff.typeReasonName = 'Mất'
        }else{
        	vm.reasonWriteOff.typeReasonName = ''
        }
        if(vm.reasonWriteOff.typeStock == '1'){
        	vm.reasonWriteOff.typeStockName = 'Kho chính'
        }else if(vm.reasonWriteOff.typeStock == '2'){
        	vm.reasonWriteOff.typeStockName = 'Kho chi nhánh'
        }else if(vm.reasonWriteOff.typeStock == '3'){
        	vm.reasonWriteOff.typeStockName = 'Tất cả'
        }else{
        	vm.reasonWriteOff.typeStockName = ''
        }
        var unsubscribe = $rootScope.$on('setupApp:reasonWriteOffUpdate', function(event, result) {
            vm.reasonWriteOff = result;
            
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
